export default "__VITE_ASSET__59139079__"